/**
 * TanStack Query Client設定
 * データフェッチングのキャッシュ戦略とエラーハンドリングを管理
 */

import { QueryClient } from '@tanstack/react-query';

// デフォルトのキャッシュ時間（ミリ秒）
const FIVE_MINUTES = 5 * 60 * 1000;
const TEN_MINUTES = 10 * 60 * 1000;
const THREE_MINUTES = 3 * 60 * 1000;

/**
 * QueryClientのインスタンスを作成
 * デフォルト設定を適用
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // データが古くなるまでの時間（この時間内はキャッシュから取得）
      staleTime: FIVE_MINUTES,
      // キャッシュに保持する時間（未使用のデータを削除するまでの時間）
      gcTime: TEN_MINUTES, // 旧cacheTime
      // エラー時のリトライ回数
      retry: 1,
      // リトライ間隔（ミリ秒）
      retryDelay: 1000,
      // ウィンドウフォーカス時の自動再取得を無効化（必要に応じて有効化）
      refetchOnWindowFocus: false,
      // ネットワーク再接続時の自動再取得を有効化
      refetchOnReconnect: true,
    },
    mutations: {
      // Mutationのリトライ回数（自動再試行を無効化）
      retry: 0,
    },
  },
});

/**
 * キャッシュ時間の定数（各Query Hookで個別に設定可能）
 */
export const CACHE_TIME = {
  ACCOUNTS_LIST: FIVE_MINUTES,
  ACCOUNT_DETAIL: TEN_MINUTES,
  FAVORITES: THREE_MINUTES,
} as const;
